<template>
  <div class="brands-checkbox">
    <ul>
      <li v-for="brand in brands.list" v-if="brands.filters.indexOf(brand.id) >= 0"   :class="{'selected': isSelected(brand.id)}" @click="select(brand.id)" >
        <input type="checkbox" :checked="isSelected(brand.id)" />
        <span v-if="brand.iphname">{{decode(brand.iphname)}}</span>
        <span v-else="">{{decode(brand.name)}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import  htmlspecialchars_decode from "locutus/php/strings/htmlspecialchars_decode"

  export default {

    computed: {
      ...mapState({
        brands: state => state.brands,
        search: state => state.search,
      }),
    },
    methods: {
      decode(text) {
        return htmlspecialchars_decode(htmlspecialchars_decode(text));
      },
      isSelected(id) {
        return this.search.producerList.indexOf(id) >= 0;
      },

      select(id) {
        let index = this.search.producerList.indexOf(id);
        if (index > -1) {
          this.search.producerList.splice(index, 1);
        } else {
          this.search.producerList.push(id);
        }
        this.$store.dispatch('search/selectedProducer', this.search.producerList);
        this.$router.replace({ name: 'searchPage'});
      },
    },
    beforeMount() {
      this.$store.dispatch('brands/requestData');
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/brands/src/BrandsCheckBox.vue